import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, NgZone, Output, inject, input } from '@angular/core';

import { TabBarEvent } from '@frontend/sports/web/tab-bar-utils';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxStrategyProvider } from '@rx-angular/cdk/render-strategies';

import { MediaTabBarItem } from './media-component-map.service';

@Component({
    selector: 'ms-media-tab-bar',
    templateUrl: 'media-tab-bar.component.html',
    styleUrls: ['media-tab-bar.component.scss'],
    imports: [CommonModule, IconCustomComponent],
})
export class MediaTabBarComponent {
    tabs = input.required<MediaTabBarItem[]>();
    @Output() select = new EventEmitter<TabBarEvent>();

    @HostBinding('class')
    get componentClass(): string {
        return `${this.hostClass}`.trim();
    }

    get hostClass(): string {
        return 'media-tab-bar media-tab-bar-var-scope';
    }

    get containerClass(): string {
        return 'tab-bar-container';
    }

    get itemClass(): string {
        return 'tab-bar-item';
    }

    get active(): MediaTabBarItem | undefined {
        return this.tabs()
            .filter((tab) => tab.active)
            .pop();
    }

    private ngZone = inject(NgZone);

    constructor(private strategy: RxStrategyProvider) {}

    selected(event: Event, selected: MediaTabBarItem): void {
        event.preventDefault();

        const canBeSelected = !selected.disabled && !selected.active;
        if (canBeSelected) {
            this.tabs().forEach((tab) => (tab.active = tab.id === selected.id));

            this.strategy
                .schedule(
                    () => {
                        this.select.emit({ ...event, active: selected });
                    },
                    { scope: this, patchZone: this.ngZone },
                )
                .subscribe();
        }
    }

    tabClass(tab: MediaTabBarItem): string {
        let classes = this.itemClass;

        if (tab.active) {
            classes += ' active';
        }

        if (tab.disabled) {
            classes += ' disabled';
        }

        return classes;
    }

    tabFormatted(text: string): boolean {
        return text?.includes('<');
    }
}
